import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Meeting } from '../../../models/meeting';
import { MeetingsService } from '../../../services/meetings.service';
import { AgentsService } from '../../../services/agents.service';
import { AgentUtility } from '../../../util';
import { AppComponent } from "../../../app.component";
import { Router } from '@angular/router';

@Component({
  selector: 'app-meeting-card',
  templateUrl: './meeting-card.component.html',
  styleUrls: ['./meeting-card.component.css']
})
export class MeetingCardComponent implements OnInit {

  @Input() meeting:Meeting;
  @Input() isAdmin:boolean;
  @Output() onConfirm:EventEmitter<any> = new EventEmitter<any>();
  @Output() onEdit:EventEmitter<any> = new EventEmitter<any>();

  PersonId:number = 0;

  constructor(private mettingsService:MeetingsService, private appComponent: AppComponent, private router: Router) {
    
   }

  ngOnInit() {
    //this.getPersonInfo();
    this.PersonId = this.meeting.PersonId;
  }

  Confirm(){
    this.mettingsService.confirmMeeting(this.meeting.Id).subscribe(data =>{
      if(data.status == "OK")
        this.onConfirm.emit(this.meeting);
    })
  }

  editRedirect(){
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(() =>
    this.router.navigate(["/meetings/edit//" + this.meeting.Id]));
    this.onEdit.emit({})
    this.appComponent.closeNeedResult();
    //window.location.reload();
  }

  editRedirectLink(){
    this.onEdit.emit({})
    this.appComponent.closeNeedResult();
    //window.location.reload();
  }

  getPersonInfo(){
    this.mettingsService.getClientInfo(this.meeting.Id).subscribe(data => {
      let peoples = data.data
      this.PersonId = peoples? peoples.length == 1? peoples[0].Id : 0 : 0;
    })
  } 
   
  getPhone(phone:string):string{
    if(!phone)
      return "+7 (";
    if(phone == "")
      return "+7 (";
    let type:string = phone.length < 3? "SHORT" : phone.length == 3? "MIDDLE" : "LONG";
    let result:string;
    switch(type){
      case "SHORT":
        result = `+7 (${phone.slice(0,phone.length)}`;
        break;
      case "MIDDLE":
        result = `+7 (${phone.slice(0,3)})`;
        break;
      case "LONG":
        let middleCode = phone.slice(3,6);
        let endCode = phone.length >= 6? phone.slice(6) : "";
        result = endCode == "" ? `+7 (${phone.slice(0,3)}) ${middleCode}` : `+7 (${phone.slice(0,3)}) ${middleCode} ${endCode}`;
        break;
    }
    return result;
  }

}
